const translations = {
  COMMON: {
    APPROVE: 'Aprobar',
    ACTIONS: 'Acciones',
    ADD_PRODUCT: 'Agregar Producto',
    ADD_SEGMENT: 'Agregar Segmento',
    ACCREDITED: 'Acreditado',
    ACCEPT: 'Aceptar',
    ADD: 'Agregar',
    ACCOUNT_NUMBER: 'Número de cuenta',
    ACCOUNT_LINK_TITLE: 'Descargar cuentas',
    ADDITIONAL_DATA: 'Información adicional',
    ADJUSTMENT_CREDIT: 'Crédito por ajuste de saldo manual',
    ADJUSTMENT_DEBIT: 'Débito por ajuste de saldo manual',
    ALIAS: 'Alias',
    ALL: 'Todos',
    AMOUNT: 'Importe',
    APP_TITLE: 'Nubi Backoffice',
    AREA_LABEL: 'Área',
    OPTION_WITHOUT_AREAS: 'Sin áreas',
    ARE_YOU_SURE: '¿Estás seguro?',
    BALANCE: 'Saldo',
    BALANCE_AVAILABLE: 'Saldo disponible',
    BALANCE_RECOVERY_ACCOUNT: 'Recupero de saldo de cuenta n° {{accountNumber}}',
    BALANCE_RECOVERY: 'Recupero de saldo',
    ASSIGNMENT: 'Asignación de presupuesto',
    REASSIGNMENT: 'Recupero de presupuesto',
    ASSIGNMENT_TO_AREA: 'Asignación de presupuesto a {{areaName}}',
    REASSIGNMENT_TO_AREA: 'Recupero de presupuesto de {{areaName}}',
    RECOVERY: 'Recupero de saldo',
    BIRTH_DATE: 'Fecha de nacimiento',
    CANCEL: 'Cancelar',
    CHOOSE_COMPANY: 'Elegí razón social',
    CHOOSE_SEGMENT_COMPANY: 'Elegí razón social y segmento',
    CHOOSE_SEGMENT: 'Elegí el segmento',
    CLEAR: 'Borrar',
    CARD: 'Tarjeta',
    CARD_STATUS: {
      ACTIVATED: 'Activa',
      LOST: 'Denunciada',
      BLOCKED: 'Bloqueada',
      REQUESTED: 'Solicitada',
      AVAILABLE: 'Pendiente de activación',
      PRINTED: 'Física',
      PRINTING: 'Printing',
      UNKNOWN: 'Unknown',
    },
    CATEGORY: 'Rubro',
    CLOSE: 'Cerrar',
    COLLAPSE_FILTERS: 'Contraer filtros',
    COMMERCE: 'Comercio',
    COMPANY: 'Razón social',
    COMPANY_GROUP: 'Grupo empresarial',
    COMPANY_KEY: 'Clave de empresa',
    COMPANY_NAME: 'Nombre',
    COMPLETED: 'Finalizado',
    CONCEPT: 'Concepto',
    CONFIRM: 'Confirmar',
    CONTINUE: 'Continuar',
    CORPORATE_DISPERSION: 'Dispersión tarjeta jurídica',
    COST_CENTER: 'Centro de costos',
    CUIL: 'CUIL',
    CUIT: 'CUIT',
    CURRENCY: 'Moneda',
    CUSTOMER_NAME: 'Razón social',
    CUSTOMER_TYPE_LABEL: 'Tipo de cliente: {{customerType}}',
    CUSTOMER_TYPE: 'Tipo de cliente',
    CREATED_BY: 'Creado por',
    CREATED_AT: 'Fecha de creación',
    CVU: 'CVU',
    DATE: 'Fecha',
    DELETE: 'Eliminar',
    DESCRIPTION: 'Descripción',
    DISPERSION: 'Dispersión de fondos',
    DNI: 'DNI',
    DOWNLOAD: 'Descargar',
    EDIT: 'Editar',
    EMAIL: 'Email',
    ENTITY: 'Razón social',
    EXECUTED_BY: 'Ejecutado por',
    EXPAND_FILTERS: 'Expandir filtros',
    EXPORT: 'Exportar',
    FROZEN_BALANCE: 'Saldo pendiente detectado',
    CONTACT_EMAIL: 'Email de contacto',
    PROVIDER: 'Proveedor',
    CARD_TYPE: 'Tipo de tarjeta',
    EXPIRATION_DATE: 'Vencimiento',
    COMPANY_TYPE: 'Tipo de empresa',
    FAILED: 'Error',
    FILE: 'archivo',
    FILTER: 'Filtrar',
    FANTASY_NAME: 'Nombre de fantasía',
    F: 'Femenino',
    FEMALE: 'Femenino',
    FIRST_NAME: 'Nombre',
    FROM_DATE: 'Fecha desde',
    FULL_NAME: 'Nombre y apellido',
    FUNDING: 'Transferencia de fondos',
    FUNDS_TRANSFER: 'Transferencia de fondos',
    GENDER: 'Género',
    GO_BACK: 'Volver',
    HELLO: '¡Hola!',
    HIDE_AMOUNT: '$****',
    HIDE_AMOUNT_TOOLTIP: 'Saldo oculto por ser producto Beneficio',
    INCOMPLETE: 'Incompleto',
    LAST_FOUR_DIGITS: 'Últimos 4 dígitos',
    LAST_NAME: 'Apellido',
    LOADING_OPTIONS: 'Cargando opciones...',
    NAME: 'Nombre',
    M: 'Masculino',
    MALE: 'Masculino',
    MANUAL_ADJUSTMENT: 'Ajuste manual',
    MONTH: 'Mes',
    NO_INFORMATION: '- Sin información -',
    NO_BALANCE: '$ -',
    NO_RESULTS_SEARCH: 'No se encontraron resultados.',
    NO: 'No',
    OPTION_NOT_FOUND: 'No se encontró la opción',
    OPTIONS_ERROR: 'Ocurrió un error al cargar las opciones',
    PENDING: 'Pendiente',
    PHONE_NUMBER: 'Número de teléfono',
    PROCESSING: 'En proceso',
    PRODUCT: 'Producto',
    REGISTER_COMPANY_IN_PRISMA: 'Alta de cliente en Prisma',
    REJECT: 'Rechazar',
    SAVE: 'Guardar',
    SEARCH: 'Buscar',
    SEE_MOVEMENTS: 'Ver movimientos',
    SEE_REPORT: 'Ver reporte',
    SEE_REPORTS: 'Ver reportes',
    SEGMENT: 'Segmento',
    SELECT_COMPANY: 'Seleccioná una razón social',
    SELECT_DATE_PLACEHOLDER: 'Seleccionar fecha',
    SELECT_PLACEHOLDER: 'Seleccioná una opción',
    SELECT_SEGMENT: 'Seleccioná un segmento',
    SELECT_ERROR: 'Ocurrió un error al cargar las opciones',
    SIGN_IN: 'Iniciar Sesión',
    SIGN_OUT: 'Cerrar Sesión',
    STATUS: 'Estado',
    SOON: 'Próximamente',
    AREA: 'Área',
    SELECT_AREA: 'Seleccioná un área',
    SELECT_AREA_SELECTOR: 'Seleccionar área',
    SUBSEGMENT: 'Sub-segmento',
    TEMPLATE_FILE_NAME: '{{type}}_template.xlsx',
    TEMPLATE_LINK_TITLE: 'Descargar plantilla',
    TOOLTIP: {
      DISPERSION:
        'Descargá aquí una plantilla .xlsx para completar el archivo de dispersión que debes enviar.',
      PROSPECT:
        'Descargá aquí una plantilla .xlsx para completar el archivo de pre-altas que debes enviar.',
    },
    TOTAL: 'Total',
    TOTAL_BALANCE: 'Balance total',
    TO_DATE: 'Fecha hasta',
    TYPE: 'Tipo',
    WALLET_ID: 'Wallet ID',
    UPDATED_AT: 'Última modificación',
    USER: 'Usuario',
    USER_ID: 'UserId',
    UNDERSTOOD: 'Entendido',
    WITHOUT_AREA: 'Sin área',
    YEAR: 'Año',
    YES: 'Si',
    ERRORS: {
      GENERIC_ERROR_TITLE: 'Ocurrió un error',
      NETWORK_ERROR: '¡Uy! Parece que no estás conectado a internet.',
      DEFAULT_ERROR: '¡Uy, algo salió mal! Volvé a intentar más tarde.',
      IT_ERROR: 'Ocurrió un error, por favor comunicate con IT.',
      INACTIVITY_LOGOUT: '¡Tu sesión expiró! Por favor, volvé a iniciar sesión.',
      LOGIN_DEFAULT_ERROR: '¡Uy, algo salió mal! Volvé a iniciar sesión.',
      CONECCTION_ERROR: 'Hubo un problema para conectar con el servidor',
      INVALID_CREDENTIALS: 'El usuario y/o contraseña son incorrectos',
      NOT_SELECTED_COMPANY_OR_SEGMENT: 'Seleccione segmento y razón social',
    },
    FILE_UPLOADS: {
      DRAG_AND_DROP: 'Soltar archivo aquí',
      BUTTON: 'Seleccionar archivo',
      DROPZONE_TEXT: 'Arrastrá y soltá tu archivo CSV, XLS o XLSX aquí',
      SUCCESS_ALERT: 'El archivo se subió exitosamente',
      ERROR_ALERT: 'Ocurrió un error al intentar subir el archivo',
      SEND_FILE_BUTTON: 'Enviar archivo',
      LINE_NUMBER: 'Línea {{number}}',
    },
    PAGINATION: {
      ROWS_PER_PAGE: 'Filas por página',
      CANCEL_SELECTION: 'Anular la selección',
      SELECT_REMAINING_ROWS: 'Seleccionar las {{count}} filas restantes',
      LABEL_DISPLAYED_ROWS: 'página {{page}} de {{total}} ({{count}} registros)',
      ALL_ROWS_SELECTED: 'Las <strong>{{count}}</strong> filas están seleccionadas',
      SELECTED_ROWS_one: '<strong>{{count}}</strong> fila seleccionada',
      SELECTED_ROWS_other: '<strong>{{count}}</strong> filas seleccionadas',
    },
    STATUSES: {
      OK: 'Ok',
      CANCELLED: 'Cancelado',
      ERROR: 'Error',
      REJECTED: 'Rechazado',
      PENDING: 'Pendiente',
    },
    TRANSACTIONS: {
      EXTERNAL_USERS: {
        CASHOUT: 'Consumo',
        CASHOUT_AUTH: 'Consumo',
        CASHOUT_AUTH_GP: 'Consumo',
        CASHOUT_AUTH_PRISMA: 'Consumo',
        CASHIN_PPCAAS: 'Dispersión en tarjeta personal',
        CASHIN_TJURIDICA: 'Dispersión en corporativa',
        CASHIN: 'Devolución',
        CASHIN_AUTH_CANCEL_GP: 'Devolución',
        ADJUST_CRED_CASHIN: 'Crédito por ajuste manual',
        ADJUST_DEB_CASHOUT: 'Débito por ajuste manual',
        CASHOUT_RECOVERY_ALL: 'Recupero de saldo',
        CASHOUT_RECOVERY: 'Recupero de saldo',
        CASHOUT_RECOVERY_PRISMA: 'Recupero de saldo',
        CASHOUT_RECOVERY_GP: 'Recupero de saldo',
        CASHOUT_EXTRACASH_PRISMA: 'Retiro Extracash',
        CASHOUT_WITHDRAW_PRISMA: 'Retiro ATM',
        RAPIPAGO_CASHOUT: 'Retiro Rapipago',
        CASHIN_EXTRACASH_CANCEL_PRISMA: 'Anulación de retiro de dinero Extracash',
        CASHIN_AUTH_CANCEL_PRISMA: 'Anulación de pago',
        CASHIN_WITHDRAW_CANCEL_PRISMA: 'Devolución retiro de efectivo',
        CASHOUT_MTT_PRISMA: 'Consumo', // deferred authorization and online authorization MIT PRISMA
        CASHOUT_MTT_FORCED_PRISMA: 'Consumo', // balance recovery PRISMA
        CASHIN_MTT_CANCEL_PRISMA: 'Devolución', // blacklist removal reversal PRISMA
        CASHIN_AUTH_PARTIAL_CANCEL_PRISMA: 'Devolución',
        CASHIN_REFUND_PRISMA: 'Devolución',
        CASHOUT_MTT_GP: 'Consumo', // deferred authorization and online authorization MIT GP
        CASHOUT_MTT_FORCED_GP: 'Consumo', // balance recovery GP
        CASHIN_MTT_CANCEL_GP: 'Devolución', // blacklist removal reversal GP
      },
    },
    VALIDATIONS: {
      AMOUNT_MUST_NOT_BE_EMPTY: 'Monto no debe estar vacío',
      AMOUNT_MUST_BE_POSITIVE_NUMBER: 'Monto debe ser un número positivo',
      MONTO_MUST_BE_TWO_DECIMALS: 'Monto con más de 2 decimales o error en el formato de la celda',
      AT_LEAST_ONE_FIELD_REQUIRED: 'Debe completar al menos un campo',
      BENEFICIO_MUST_NOT_BE_EMPTY: 'Beneficio no debe estar vacío',
      CATEGORY_MUST_NOT_BE_EMPTY: 'El rubro no debe estar vacío',
      CATEGORY_NOT_ALLOWED: 'El rubro es inválido',
      DATE_INVALID: 'Fecha inválida, el formato debe ser DD/MM/AAAA.',
      DATE_VALUE_INVALID: 'Fecha inválida',
      BIRTH_DATE_MIN: 'La fecha de nacimiento debe ser mayor a 13 años.',
      BIRTH_DATE_MAX: 'La fecha de nacimiento debe ser menor a 100 años.',
      COMPANY_NAME_LENGTH: 'La longitud máxima es 40 caracteres',
      CUIT_INVALID_LENGTH: 'Longitud inválida de CUIT',
      CUIL_INVALID_LENGTH: 'Longitud inválida de CUIL',
      CUIT_MUST_BE_A_NUMBER: 'CUIL debe ser sólo números',
      CUIT_MUST_NOT_BE_EMPTY: 'CUIL no debe estar vacío',
      DNI_INVALID_LENGTH: 'Longitud inválida de DNI',
      DNI_MUST_BE_A_NUMBER: 'DNI debe ser sólo números',
      DNI_MUST_NOT_BE_EMPTY: 'DNI no debe estar vacío',
      DNI_OR_CUIT_MISMATCH: 'CUIL y DNI no coinciden',
      EMAIL_MUST_NOT_BE_EMPTY: 'Email no debe estar vacío',
      INCONSISTENT_COLUMNS_TITLE: 'Error en las columnas del archivo',
      INCONSISTENT_COLUMNS_DESCRIPTION:
        'La cantidad de columnas no coincide con la esperada. Revisá la línea {{line}}.',
      INVALID_AMOUNT_DECIMALS_TITLE: 'Error en la columna monto',
      INVALID_AMOUNT_DECIMALS_DESCRIPTION:
        'Hay registros con más de 2 decimales y deben ser corregidos antes de avanzar.',
      INVALID_CUIL: 'CUIL inválido',
      INVALID_AMOUNT: 'Monto inválido',
      INVALID_AMOUNT_DECIMALS: 'Monto inválido, sólo se permiten hasta 2 decimales',
      INVALID_DNI_OR_CUIL: 'CUIL o DNI inválido',
      INVALID_EMAIL: 'Formato de email inválido',
      INVALID_NAME: 'El nombre es inválido',
      INVALID_LASTNAME: 'El apellido es inválido',
      INVALID_TOTAL_VALUE: 'La fila del total es inválida',
      MISSING_COLUMN: 'No se encontró la columna obligatoria "{{column}}"',
      NAME_MUST_BE_NOT_EMPTY: 'Nombre no debe estar vacío',
      NAME_MUST_BE_A_STRING: 'Nombre debe ser texto',
      NAME_AND_LAST_NAME: 'Nombres inválidos',
      LASTNAME_MUST_BE_NOT_EMPTY: 'Apellido no debe estar vacío',
      LASTNAME_MUST_BE_A_STRING: 'Apellido debe ser texto',
      NAME_LASTNAME_MIN_LENGTH: 'Longitud inválida, mínimo dos caracteres.',
      NAME_LASTNAME_MAX_LENGTH: 'Longitud inválida, máximo cuarenta caracteres.',
      ONLY_NUMBERS: 'Debe ser numérico',
      PHONE_INVALID_LENGTH:
        'Ingresá el código de tu País seguido por el de tu Localidad (Ej: 5491101234567).',
      PHONE_INVALID_AREA_CODE: 'Código de área inválido.',
      REPEATED_DNI: 'El DNI se encuentra repetido en otra línea',
      REPEATED_CUIL: 'El CUIL se encuentra repetido en otra línea',
      REPEATED_EMAIL: 'El Email se encuentra repetido en otra línea',
      REQUIRED_FIELD: 'Campo obligatorio',
      PRODUCT_MUST_NOT_BE_EMPTY: 'El producto no debe estar vacío',
      PRODUCT_NOT_ALLOWED: 'El producto es inválido',
      TIPO_TARJ_MUST_NOT_BE_EMPTY: 'Tipo de tarjeta no debe estar vacío',
      INVALID_POSTAL_CODE: 'El código postal debe tener 4 dígitos',
      AREA_NOT_ALLOWED: 'El área es inválida',
      INVALID_LENGTH: 'Longitud inválida',
      ONLY_NUMBERS_AND_LETTERS: 'Solo números y letras, sin espacios.',
    },
    CLEAR_FILTER: 'Limpiar filtros',
    CLEAR_FORM: 'Limpiar campos',
    VOUCHER: 'Comprobante',
  },
  //  new clients section
  CLIENTS: {
    ADD_CLIENT: 'Nuevo cliente',
    ADDRESS: 'Domicilio',
    BALANCE_TAB_TITLE: 'Saldo',
    CREATED_AT: 'Fecha de alta',
    CREATE_CLIENT_BUTTON: 'Alta de cliente',
    DETAILS_TAB_TITLE: 'Detalles',
    REPORTS_TAB_TITLE: 'Reportes',
    MOVEMENTS_TITLE: 'Movimientos',
    SELECT_COMPANY: 'Seleccioná una razón social',
    REQUEST_RECEIPT: 'Solicitar recibo de transferencia',
    DETAIL: {
      PRODUCT_LUNCH_DATE_TIME_RANGE: 'Leyenda de horario para producto almuerzo',
      TRX_TYPE: 'Tipo TRX',
      TRX_DAILY_LIMIT: 'Límite monto diario',
      TRX_MONTHLY_LIMIT: 'Límite monto mensual',
      SEGMENTS_LIST: 'Segmentación de usuarios',
      POSTAL_ADDRESS: {
        TITLE: 'Dirección postal',
        CITY: 'Ciudad',
        STATE: 'Provincia',
        STREET: 'Calle',
        NUMBER: 'Número',
        FLOOR_AND_APARMENT: 'Piso / Depto.',
        FLOOR: 'Piso',
        APARMENT: 'Depto',
        POSTAL_CODE: 'Código postal',
      },
      PRODUCTS_AVAILABLE: { TITLE: 'Productos disponibles' },
      AREAS: { TITLE: 'Áreas' },
      ADD_POSTAL_ADDRESS: {
        TITLE: 'Agregar dirección postal',
        SUCCESS: 'Cambios guardados con éxito.',
      },
      DONT_HAVE_POSTAL_ADDRESS: {
        OPERACIONES:
          'Aún no tenemos cargada la dirección postal. Recordá que podés hacerlo haciendo click en "Agregar dirección postal" desde las acciones arriba a la derecha de la pantalla.',
        CLIENTE:
          'Aún no tenemos cargada la dirección postal, por favor escribinos a la dirección de mail de soporte si tenes alguna duda: contacto_autogestion@nubi.com.ar.',
      },
      PUBLIC: 'Público',
      PRIVATE: 'Privado',
    },
    CREATE_AREA: {
      NAME: 'Nombre del área',
      COST_CENTER: 'Centro de costos',
      ADD: 'Agregar área',
      EDIT: 'Editar',
      EDIT_MODAL: 'Editar datos',
    },
    RECOVER_BALANCE: 'Recuperar presupuesto',
    ASSIGN_BALANCE: 'Asignar presupuesto',
    ASSIGN_PRODUCT_MODAL: {
      FAILED_TITLE: 'Ocurrió un error',
      SUCCESS_TITLE: 'Producto agregado correctamente.',
      COMPLETE_DESCRIPTION:
        '¡Listo! Has enviado con éxito la información de los siguientes productos:',
      FAILED_DESCRIPTION: 'No se ha podido agregar los siguientes productos:',
      PARTIAL_DESCRIPTION:
        '¡Listo! Has enviado con éxito la información de los productos: {{result}}.Pero los siguientes productos no pudieron ser agregados:',
    },
    CONFIRM_ASSIGN_PRODUCT: {
      MODAL_DESCRIPTION: 'Vas a asignar los siguientes productos al cliente:',
    },
    ASSIGN_BALANCE_MODAL: {
      MAX_AMOUNT_ERROR: 'El monto a asignar no puede ser mayor que el saldo disponible.',
      CONFIRMATION_DESCRIPTION:
        'Estás a punto de asignar <bold>{{amount}}</bold> al área <bold>{{areaName}}</bold>. El monto será acreditado al saldo del área y debitado del saldo de la razón social.',
      SUCCESS_TITLE: '¡Listo! ¡Presupuesto asignado exitosamente!',
      SUCCESS_DESCRIPTION:
        'Te confirmamos que el presupuesto fue asignado al área de manera exitosa.',
    },
    REASSIGN_BALANCE_MODAL: {
      REASSIGN_BALANCE_TITLE: 'Recuperar presupuesto',
      REASSIGN_BALANCE_TOTAL_HELPER: 'Vas a recuperar todo el saldo de tu área ({{balance}})',
      CONFIRMATION_DESCRIPTION_TOTAL_REASSIGMENT:
        'Estás a punto de recuperar el total del presupuesto <bold>({{amount}})</bold> del área <bold>{{areaName}}</bold>. El mismo será acreditado en el saldo de la razón social.',
      CONFIRMATION_DESCRIPTION_PARCIAL_REASSIGMENT:
        'Estás a punto de recuperar <bold>{{amount}}</bold> del área <bold>{{areaName}}</bold>. El mismo será acreditado en el saldo de la razón social.',
      SUCCESS_TITLE: '¡Listo! ¡Presupuesto recuperado exitosamente!',
      SUCCESS_DESCRIPTION:
        'Te confirmamos que el presupuesto fue asignado a la razón social de manera exitosa.',
    },
    CUSTOM_COLOR: 'Personalizar producto',
    PRODUCT_PROVIDER_ID: 'Product provider id',
    CREATE_CLIENT: {
      SUCCESS_TITLE: 'Cliente añadido correctamente.',
      SUCCESS_DESCRIPTION:
        '¡Listo! ¡Has enviado con éxito la información del nuevo cliente para su aprobación!',
      SUCCESS_WITH_ERROR_DESCRIPTION:
        '¡Listo! ¡Has enviado con éxito la información del nuevo cliente!, pero se encontraron errores:',
      ERROR_DESCRIPTION:
        'No se ha podido crear el nuevo cliente, por favor revise los siguientes errores encontrados:',
      ERROR_DETAILS: {
        GENERIC_SEGMENT_RESULT: 'Error en la asignación del segmento',
        GENERIC_S3_FOLDERS: 'Error en la creación de la carpeta en S3',
        GENERIC_PROSPECT_ADRESS: 'Error en la dirección del prospecto',
        EXIST_COMPANY_PROCESS_RESULT: 'La Razón Social de la empresa ya existe',
        EXIST_SEGMENT_RESULT: 'El Segmento de la compañía ya existe',
        INVALID_CUIT: 'CUIT inválido',
        INVALID_CUSTOMER_TYPE: 'El tipo de cliente debe ser Público o Privado',
        INVALID_ADDRESS: 'Dirección inválida',
        CUIT_ALREADY_EXISTS_AS_CUSTOMER: 'El CUIT ya existe como cliente',
        CUIT_PENDING_REQUEST: 'Ya existe una solicitud pendiente para este CUIT.',
        CUIT_APPROVED_REQUEST: 'Este CUIT ya tiene un alta aprobada.',
        DATABASE_ERROR: 'Ocurrió un error en la base de datos. Intentá de nuevo más tarde.',
      },
      ADD_SEGMENT_MODAL: {
        CONFIRMATION_MODAL_TITLE: 'Confirmar alta de segmento',
        CONFIRMATION_MODAL_DESCRIPTION: 'Vas a asignar el segmento <s>{{segment}}</s> al cliente.',
        LIMITS_ERROR: 'Error en la duplicación de límites por defecto',
        CUSTOMER_SEGMENT_CREATE_ERROR: 'Error en la asignacion de subSegmentos',
        INCOMPLETE_PROCESS: {
          TITLE: 'Se procesó con algunos errores',
          DESCRIPTION: 'No pudimos registrar el Segmento en la base de datos',
        },
        SUCCESS_TITLE: 'Se agregó con éxito el Segmento',
        SUCCESS_SEGMENT_CREATION:
          'El segmento {{segmentDisplay}} fue creado con el identificador número: {{number}}',
        BAD_REQUEST_TITLE: 'No se pudo dar de alta el Segmento',
        BAD_REQUEST_DESCRIPTION:
          'Nombre de segmento ingresado existe para la razón social seleccionada.',
      },
    },
    ADJUSTMENT: {
      MISSING_ADJUSTMENT: 'No se encontraron datos para el ajuste seleccionado.',
      DETAIL_ADJUSTMENT_TITLE: 'Detalles del ajuste',
      CUIL: 'Cuil',
      COMPANY_NAME: 'Nombre de la compañía',
      TRANSACTION_TYPE: 'Tipo de transacción',
      AMOUNT: 'Monto',
      BALANCE_BEFORE: 'Balance anterior',
      BALANCE_AFTER: 'Balance posterior',
      USER: 'Usuario',
      UPDATED_TIME: 'Fecha de actualización',
      REASON: 'Razón',
      VALUE_DATE: 'Fecha valor',
      ADJUSTMENT_ID: 'Id del ajuste',
    },
    ERRORS: {
      REGISTER_COMPANY_IN_PRISMA:
        'Hay un problema para validar si el cliente ya existe en Prisma, por favor comunícate con IT',
      INVALID_COLOR_HEX: 'Formato de color inválido',
    },
  },
  EMPLOYEES: {
    ASSIGN_PRODUCT_TITLE: 'Seleccionar nuevo producto',
    ASSIGN_PRODUCT_DESCRIPTION: 'Seleccioná nuevo producto para tu colaborador',
    PRODUCT_LABEL: 'Producto *',
    CATEGORY_LABEL: 'Rubro *',
    AREA_LABEL: 'Área *',
    SEGMENT_LABEL: 'Segmento',
    INVALID_PRODUCTS_SEARCH: 'Seleccioná una razón social para filtrar por productos',
    TITLE: 'Colaboradores',
    SEARCH_CLIENT: 'Buscar cuentas',
    MULTIPLE_SEARCH: 'Búsqueda múltiple por CUIL',
    MULTIPLE_SEARCH_TOOLTIP: 'Ingresá el CUIL y presioná la tecla Enter para añadirlo a la lista',
    MULTIPLE_SEARCH_MAX: 'Se permite un máximo de 25 CUIL.',
    MULTIPLE_SEARCH_MIN: 'El listado debe contar con al menos 2 CUIL.',
    MULTIPLE_SEARCH_DUPLICATED_VALUE: 'El CUIL ingresado ya se encuentra en el listado.',
    MULTIPLE_SEARCH_INVALID_CUILS: 'Los siguientes CUIL no son válidos: {{cuils}}',
    MULTIPLE_SEARCH_EXCLUDED_CUILS_LIMIT:
      'No se pudieron agregar estos CUIL porque se excedió el límite de 25: {{cuils}}',
    REQUIRES_LEGAL_CARD: '¿Requiere tarjeta jurídica?',
    PROSPECT_CREATE: 'Prealta de colaborador',
    STATUS: {
      REGISTERED: 'Registrado',
      PROSPECT: 'Prospecto',
      ONBOARDING: 'Onboarding',
      DELETED: 'Eliminado',
      ACTIVATED: 'Activa',
      LOST: 'Denunciada',
      BLOCKED: 'Bloqueada',
      REQUESTED: 'Solicitada',
      AVAILABLE: 'Pendiente',
      PRINTED: 'Física',
      PRINTING: 'Printing',
      UNKNOWN: 'Unknown',
    },
    STATUS_TOOLTIP: {
      REGISTERED: 'Registrado',
      PROSPECT: 'Prospecto',
      ONBOARDING: 'Onboarding',
      DELETED: 'Eliminado',
      ACTIVATED: 'Activa',
      LOST: 'Denunciada',
      BLOCKED: 'Bloqueada',
      REQUESTED: 'Solicitada',
      AVAILABLE: 'Pendiente de activación',
      PRINTED: 'Física',
      PRINTING: 'Printing',
      UNKNOWN: 'Unknown',
    },
    ASSIGN_AREA_MODAL: {
      MODAL_TITLE: 'Seleccionar un área',
      MODAL_DESCRIPTION: 'Seleccioná un área para asignar a la cuenta',
      MODAL_DESCRIPTION_PARTIAL: 'Se asignará el área elegida a las cuentas seleccionadas',
      SUCCESS_TITLE: 'Confirmación de área asignada',
      SUCCESS_DESCRIPTION:
        'Las cuentas seleccionadas fueron asignadas al área {{areaname}} con éxito.',
      ALREADY_HAVE_AREAS_TITLE: 'Se han encontrado errores',
      ALREADY_HAVE_AREAS_DESCRIPTION:
        'Para asignar área es necesario que las cuentas seleccionadas pertenezcan a la misma razón social y no posean áreas vinculadas.',
      HAS_BALANCE_TITLE: 'Se han encontrado errores',
      HAS_BALANCE_DESCRIPTION: 'No se puede asignar área debido a que la cuenta posee saldo',
    },
    ASSIGN_PRODUCT: {
      BUTTON: 'Asignar nuevo producto',
      MODAL_TITLE: 'Seleccionar nuevo producto',
      MODAL_DESCRIPTION: 'Seleccioná nuevo producto para tu colaborador',
      CONFIRM_MODAL_TITLE: 'Confirmación nuevo producto asignado',
      CONFIRM_MODAL_DESCRIPTION_other:
        'Tus colaboradores ya tienen el producto {{product}} con su nueva tarjeta Nubi activa para los rubros: {{categories}}',
      CONFIRM_MODAL_DESCRIPTION_one:
        'Tus colaboradores ya tienen el producto {{product}} con su nueva tarjeta Nubi activa para el rubro: {{categories}}',
      ERROR_TITLE: 'Se han encontrado errores',
      ERROR_DESCRIPTION: 'Lo sentimos, no hemos podido agregar {{product}} debido a:',
      DIFFERENT_CUSTOMERS_ERROR_TITLE:
        'Se han encontrado errores, cuentas de distintas razones sociales',
      DIFFERENT_CUSTOMERS_ERROR_DESCRIPTION:
        'Por favor, seleccioná cuentas de una única razón social para continuar',
      DIFFERENT_AREAS_ERROR_TITLE: 'Se han encontrado errores, cuentas de distintas áreas',
      DIFFERENT_AREAS_ERROR_DESCRIPTION:
        'Para dispersar fondos es necesario que las cuentas seleccionadas pertenezcan a la misma área. Por favor escribinos a la dirección de mail de soporte: contacto_autogestion@nubi.com.ar.',
      SEGMENT_ERROR: 'El segmento seleccionado no es válido para el colaborador',
    },
    RETRIEVE_BALANCE: {
      PRODUCTS_NOT_ALLOWED_TITLE:
        'Sólo podés recuperar saldo de los productos con tarjeta corporativa o almuerzo',
      PRODUCTS_NOT_ALLOWED_DESCRIPTION:
        'Algunos productos seleccionados no cumplen esta condición. Podés utilizar previamente el filtro de producto para facilitar tu operación.',
      POSITIVE_BALANCE_TITLE: 'Se han encontrado errores, colaboradores sin saldo',
      POSITIVE_BALANCE_DESCRIPTION:
        'No podés continuar con esta acción porque sólo podes recuperar saldo si la cuenta tiene saldo positivo',
      MODAL_TITLE: '¿Querés continuar con esta acción?',
      MODAL_MESSAGE:
        'Estás a punto de recuperar <bold>{{total}}</bold> entre <bold>{{count}}</bold> cuentas de <bold>{{companyName}}</bold>. ¿Estás de acuerdo con este monto?',
      MODAL_MESSAGE_WITH_WARNING:
        'Estás a punto de recuperar <bold>{{total}}</bold> entre <bold>{{count}}</bold> cuentas de <bold>{{companyName}}</bold>. <br><br> Recordá que sólo podes recuperar saldo si la cuenta tiene saldo positivo. <br><br> ¿Estás de acuerdo con este monto?',
      RECOVERY_SUCCESS_TITLE: 'Te confirmamos que recupertaste tu saldo de manera exitosa',
      RECOVERY_GO_TO_MY_BALANCE: 'Ir a Mi Saldo',
      RECOVERY_GO_TO_MY_BALANCE_INTERNAL: 'Ir al Cliente',
      RECOVER_SUCCESS_BODY: 'Podés ver el mismo actualizado en la opción Mi saldo.',
      RECOVER_SUCCESS_BODY_INTERNAL: 'Podés ver el mismo actualizado en la opción Cliente.',
      RECOVERY_ERROR_TITLE: 'Ocurrió un error inesperado',
      RECOVER_ERROR_BODY:
        'Por favor volvé a intentarlo. Si el problema persiste por favor contactate con Soporte: contacto_autogestión@nubi.com.ar',
    },
    ONBOARDING: {
      VALIDATE_ONBOARDING: 'Validar onboarding',
      MODAL_TITLE: 'Revisá todos los datos',
      BIRTH_DATE: 'Fecha de nacimiento',
      NACIONALITY: 'Nacionalidad',
      TITLE: 'Edición de datos biométricos',
      BUTTON_TEXT: 'Actualizar',
      MODAL: {
        SUCCESS_TITLE: 'Actualización exitosa',
        SUCCESS_MESSAGE: 'Los datos biométricos fueron actualizados correctamente.',
        ERROR_TITLE: 'Error al actualizar',
        ERROR_MESSAGE: 'Hubo un problema al actualizar los datos.',
      },
    },
    DETAIL: {
      ACCOUNT: 'Cuenta',
      ACCOUNTS: 'Cuentas',
      LINK: 'Ver enlace',
      VIEW_BANNERS: 'Ver banners',
      EMPTY_LAST_LOGIN_AT: 'Aún no se registra ingreso',
      LAST_LOGIN_AT: 'Último ingreso a la app',
      ACCOUNT_CREATED_AT: 'Fecha de alta',
      ACCOUNT_NUMBER: 'Número de cuenta',
      ALLOW_DISPERSION: 'Habilitar dispersión',
      ALLOW_DISPERSION_MODAL_DESCRIPTION:
        '¿Estás seguro que querés habilitar la dispersión para esta cuenta? Se mostrará esta cuenta dentro del listado de dispersión rápida.',
      ENABLE_DISPERSION: 'Habilitado para dispersión',
      BALANCE_TOTAL: 'Saldo',
      BALANCE_FROZEN: 'Saldo inmovilizado',
      BALANCE_AVAILABLE: 'Saldo disponible',
      BALANCE_RECOVERY: 'Recupero de saldo',
      BENEFITS_AVAILABLE: 'Rubro',
      CLIENT_DETAILS: 'Detalles',
      NO_ASSIGNATION: 'Sin asignación',
      //TODO: Confirm Modal is used for both clients and employees, we should refactor it
      CONFIRM_MODAL_DESCRIPTION:
        '¿Deseas actualizar la información del colaborador? Datos a modificar: {{changedValues}}',
      CONFIRM_MODAL_TITLE: 'Modificación de colaborador',
      DISPERSE: 'Dispersar',
      EDIT_CATEGORIES: 'Editar',
      DISABLE_DISPERSION: 'Deshabilitar dispersión',
      SUCCESS_DISABLE_DISPERSION: 'Se deshabilitó la dispersión con éxito.',
      SUCCESS_ENABLE_DISPERSION: 'Se habilitó la dispersión con éxito.',
      DISABLE_DISPERSION_MODAL_DESCRIPTION:
        '¿Estás seguro que querés deshabilitar la dispersión para esta cuenta? No se mostrará esta cuenta dentro del listado de dispersión rápida.',
      EDIT_CATEGORIES_SUCCESS: 'Cambios guardados con éxito.',
      EDIT_CATEGORIES_FAILED_SAME_PRODUCT_TITLE: 'Atención',
      EDIT_CATEGORIES_FAILED_SAME_PRODUCT_DESCRIPTION:
        'El colaborador ya posee este combinación de rubros asociada. Debe contener al menos un rubro diferente para continuar',
      GP_ACCOUNT_NUMBER: 'Número de cuenta GP',
      MOVEMENTS: 'Movimientos',
      NO_PRODUCTS_MESSAGE: 'El usuario no posee productos',
      OVERVIEW: 'Resumen',
      SUCCESS_EDIT: 'Se ha modificado el colaborador con éxito.',
      SUCCESS_RESEND_MAIL: 'El mail fue enviado correctamente.',
      PRODUCT: 'Producto',
      SUCCESS_RESEND_EMAIL: 'El email fue enviado correctamente.',
      PRODUCTS: 'Productos',
      PRODUCTS_CARD_TITLE: 'Tarjeta #{{ count }}',
      PRODUCTS_ACCOUNT_TITLE: 'CVU',
      EDIT: 'Editar',
      ASSIGN_AREA: 'Asignar área',
      BANNERS: {
        TITLE: 'Banners',
        LOADING: 'Cargando banners',
      },
      REQUEST_PHYSICAL_CARD: {
        TITLE_MENU: 'Solicitar plástico',
        CONFIRM_MODAL_TITLE: '¿Querés continuar con esta acción?',
        CONFIRM_MODAL_TEXT:
          'Esta tarjeta se enviará a la dirección <bold>{{postalAddress}}, {{floor}}{{apartment}}{{cityName}}, {{stateName}}</bold>, de la razón social <bold>{{legalName}}</bold>. Para modificarla comunicarse con IT.',
        CONFIRM_MODAL_TEXT_FLOOR: 'Piso {{floor}}, ',
        CONFIRM_MODAL_TEXT_APARTMENT: 'Dpto {{apartment}}, ',
        MISSING_POSTAL_ADDRESS_TITLE: 'No podemos realizar esta acción',
        MISSING_POSTAL_ADDRESS_TEXT:
          'El cliente no tiene cargada una dirección postal. Recordá que podes cargarla desde el BO en la opción Clientes/Agregar dirección postal',
        GET_POSTAL_ADDRESS_ERROR: 'Hubo un error al obtener la dirección postal',
        SUCCESS_TITLE: '¡Listo! ¡La tarjeta pronto estará en camino!',
        SUCCESS_TEXT:
          'Te confirmamos que la tarjeta ya quedó solicitada. Llegará en aproximadamente 2 días a la dirección del cliente.',
        ERROR: 'Ocurrió un error, por favor comunicate con IT.',
        PHYSICAL_CARD_ALREADY_REQUESTED: 'La tarjeta física ya se solicitó',
      },
      REGISTER_STATUS: 'Estado del registro',
      RESEND_EMAIL_BUTTON: 'Reenviar registro',
      RESEND_EMAIL: 'Reenvío de email de registro',
      RESEND_EMAIL_DESCRIPTION: 'Se va a reenviar un email a <1>{{email}}</1>',
      RETRIEVE_BALANCE: 'Recuperar saldo',
      RETRIEVE_BALANCE_AMOUNT_PLACEHOLDER: 'Ingresá el monto a recuperar',
      RETRIEVE_BALANCE_TITLE: 'Recuperá el saldo',
      RETRIEVE_BALANCE_TOTAL_HELPER:
        'Vas a recuperar todo el saldo de tu colaborador ({{balance}})',
      RETRIEVE_BALANCE_SUCCESS: '¡Recuperaste tu saldo con éxito!',
      RETRIEVE_PARTIAL_AMOUNT: 'Recuperar un monto parcial del saldo',
      PRODUCTS_REQUEST_PHYSICAL_CARD: 'Solicitar Tarjeta Física',
      VIEW_DETAIL: 'Ver detalle',
      VIEW_ALL_MOVEMENTS: 'Ver todos los movimientos',
      WITHOUT_CATEGORY: 'Sin rubros',
      WITHOUT_PRODUCT: 'N/A',
      CARD_TYPE: {
        PERSONAL: 'Personal',
        BUSINESS: 'Jurídica',
      },
      STATUS: {
        REGISTERED: 'Usuario registrado',
        NOT_REGISTERED: 'Usuario pendiente de registro',
        DELETED: 'Usuario eliminado',
        UNDEFINED: 'Dato no provisto o no existente.',
      },
      ERRORS: {
        INVALID_BIRTH_DATE:
          'Verificá que la fecha sea válida en formato DD/MM/AAAA y mayor a 16 años.',
        RETRIEVE_BALANCE_TITTLE: '¡Vaya! Algo salió mal',
        RETRIEVE_BALANCE_CONTENT:
          'Intentá de nuevo en unos minutos o contactá al equipo de soporte.',
        EDIT_ERROR: 'Ocurrió un error al editar los datos del colaborador.',
        BENEFITS_EDIT_ERROR: 'Ocurrió un error al editar los beneficios del colaborador',
        PROVIDER_ERROR:
          'Los datos no fueron actualizados correctamente en el proveedor de tarjetas.',
        CLIENT_FETCH_GENERIC_ERROR: 'Ocurrió un error al obtener la información del colaborador.',
        CLIENT_DETAIL_FETCH_GENERIC_ERROR:
          'Lo sentimos, no logramos cargar la información del colaborador seleccionado. Por favor, reintente más tarde.',
        ACCOUNT_FETCH_GENERIC_ERROR: 'Ocurrió un error al obtener la información de la cuenta.',
        EMAIL_ALREADY_EXISTS: 'Email ya asignado a otro usuario. No se actualizaron los datos.',
        PRODUCTS_FETCH_GENERIC_ERROR:
          'Ocurrió un error al obtener la información de los productos.',
        UNABLE_TO_SEE_TAB: 'El usuario no puede acceder a esta sección.',
        WARNING_FAILED_FIELDS:
          'No pudimos guardar todos los cambios. Los siguientes campos no pudieron ser actualizados: {{fields}}',
        FAIL_SENDIG_MAIL: 'No pudimos enviar el email de registro actualizado al usuario.',
        FAIL_RESEND_EMAIL: 'No se pudo enviar el email, por favor intentá nuevamente.',
        PHONE_ALREADY_EXISTS:
          'Número de teléfono ya asignado a otro usuario. No se actualizaron los datos.',
        CUIL_ALREADY_EXISTS: 'CUIL ya asignado a otro usuario. No se actualizaron los datos.',
      },
      VALIDATIONS: {
        AMOUNT_EXCEEDS_TOTAL_BALANCE:
          'El monto a recuperar no puede ser mayor que el total del saldo ({{totalBalance}}).',
      },
      USER_STATUS: {
        REGISTERED: 'Usuario registrado',
        ONBOARDING: 'Usuario pendiente de registro',
        PROSPECT: 'Usuario con email pendiente de envío',
        UNKNOWN: '-',
        DELETED: 'Usuario eliminado',
      },
    },
    ERRORS: {
      GENERIC_ERROR: 'Ocurrió un error al buscar clientes',
      INVALID_SEARCH:
        'La consulta realizada es inválida. Por favor revisá los parámetros de búsqueda.',
    },
  },
  COMMERCES: {
    ADD_COMMERCE: 'Agregar comercio',
    COMMERCE_SAVED_MESSAGE: 'Ya guardamos el nuevo comercio.',
    COMMERCE_SAVED_TITLE: 'Éxito',
    COMMERCE_DELETED_MESSAGE: 'Ya no está más el comercio en nuestros datos.',
    COMMERCE_DELETED_TITLE: 'Comercio eliminado',
    SECTION_TITLE: 'Gestión de comercios',
    DELETE_COMMERCE: 'Borrar comercio',
    DELETE_WARNING: 'Vas a eliminar el comercio',
    MCC: 'MCC',
    NAME: 'Nombre del comercio',
    BENEFIT: 'Beneficio',
    ERRORS: {
      COMMERCE_NOT_FOUND: 'No se encontró el comercio',
      UNABLE_TO_DELETE: 'Tuvimos un problema intentando eliminar el comercio.',
      UNABLE_TO_SAVE: 'Tuvimos un problema intentando guardar el comercio.',
      REQUIRED_FIELDS_TO_SAVE: 'Los 3 campos son obligatorios, el MCC requiere de 4 dígitos',
      INVALID_SEARCH: 'No se pudo realizar la búsqueda. Verificar el nombre de comercio',
    },
  },
  DISPERSIONS: {
    FILTERS_TITLE: 'Filtrar dispersiones',
    AMOUNT: 'Monto',
    ACCOUNT: 'Cuenta',
    ACCREDITED: 'Acreditados',
    DISPERSE: 'Dispersar',
    DISPERSION: 'Dispersión',
    ORIGINAL_AMOUNT: 'Monto original',
    REAL_AMOUNT: 'Monto real dispersado',
    CSV_ERRORS_TITLE: 'Encontramos los siguientes errores en tu archivo de dispersión:',
    CANCELLED: {
      TITLE_MODAL_CONFIRM: '¿Querés continuar con esta acción?',
      DESCRIPTION_MODAL_CONFIRM:
        'Estás a punto de cancelar la dispersión de <bold>{{name}}</bold> programada para el día <bold>{{date}}</bold> a las <bold>{{time}}</bold> hrs.',
      SUCCESS: {
        TITLE: 'Dispersión cancelada con éxito',
        DESCRIPTION: 'La dispersión ha sido cancelada correctamente.',
      },
      ERROR: {
        TITLE: 'Error al cancelar la dispersión',
        DESCRIPTION_404: 'No se encontró la dispersión solicitada.',
        DESCRIPTION_500: 'Ocurrió un error en el servidor al intentar cancelar la dispersión.',
        DESCRIPTION_503: 'El servicio de dispersión no está disponible en este momento.',
        DESCRIPTION_410:
          'No es posible cancelar esta dispersión porque quedan menos de 5 minutos para su ejecución.',
      },
    },
    DISPERSION_DATE: 'Fecha programada',
    FILE_DISPERSION: 'Dispersar archivo',
    HEADING: '¡Ya podés comenzar con la dispersión de fondos para {{name}}!',
    INPUT_LABEL_DATE: 'Fecha a dispersar',
    INPUT_LABEL_SWITCH: 'Programar dispersión',
    INSTANT: 'Instantánea',
    MODAL_MESSAGE_INSTANT:
      'Estás a punto de dispersar <bold>{{total}}</bold> entre <bold>{{count}}</bold> de tus colaboradores de <bold>{{companyName}}</bold>. ¿Estás de acuerdo con este monto?',
    MODAL_MESSAGE_INSTANT_WITH_MESSAGE:
      'Estás a punto de dispersar <bold>{{total}}</bold> entre <bold>{{count}}</bold> de tus colaboradores de <bold>{{companyName}}</bold>. Recibirán la notificación personalizada <bold>{{message}}</bold> en su aplicación móvil. ¿Estás de acuerdo?',
    MODAL_MESSAGE_SCHEDULED:
      'Estás programando una dispersión de <bold>{{total}}</bold> entre <bold>{{count}}</bold> de tus colaboradores de <bold>{{companyName}}</bold> para que se ejecute el día <bold>{{formatDay}}</bold> a las <bold>{{formatTime}}</bold> hrs.',
    MODAL_TITLE: '¿Querés continuar con esta acción?',
    MY_DISPERSIONS: 'Mis dispersiones',
    SEARCH_MY_DISPERSIONS: 'Buscar dispersiones',
    SCHEDULE_TYPE: 'Tipo de dispersión',
    SCHEDULE_TYPE_ALL: 'Todos',
    SCHEDULE_TYPE_INSTANT: 'Instantánea',
    SCHEDULE_TYPE_SCHEDULED: 'Programada',
    STATUS_FILTER_ALL: 'Todos',
    STATUS_DESCRIPTION_FAILED: 'Ocurrió un error inesperado durante la subida del archivo.',
    STATUS_DESCRIPTION_INCOMPLETE:
      'Recibimos tu archivo pero algunos colaboradores no pudieron ser procesados',
    STATUS_DESCRIPTION_PENDING: 'Recibimos tu archivo y está pendiente a ser procesado.',
    SCHEDULE_TITLE: 'Programar fecha a dispersar',
    SCHEDULE_TEXT:
      'El dinero se dispersará de manera automática en la fecha que hayas seleccionado',
    SELECT_COMPANY: 'Seleccioná la razón social',
    UPLOAD_FILE: 'Subir archivo de dispersión',
    UPLOAD_DATE: 'Fecha de carga',
    ATTEMPTED_AMOUNT: 'Monto original',
    DISPERSED_AMOUNT: 'Monto acreditado',
    DISPERSIONS_SUCCESS_TITLE_INSTANT: '¡Has enviado tu archivo exitosamente!',
    DISPERSIONS_SUCCESS_BODY_INSTANT:
      'En breve te estaremos enviando por correo los resultados del procesamiento de tu archivo.\n\nTambién podés ver los resultados desde “Mis dispersiones”.',
    DISPERSIONS_SUCCESS_TITLE_SCHEDULED: '¡Dispersión programada exitosamente!',
    DISPERSIONS_SUCCESS_BODY_SCHEDULED:
      'Tu dispersión de fondos ha sido programada y se ejecutará en la fecha que has seleccionado.\n\nTambién podés ver los resultados desde “Mis dispersiones”.',
    GO_TO_DISPERSIONS: 'Ir a Mis dispersiones',
    ERRORS: {
      CONFIRMATION_ERROR_TITLE: 'No pudimos dispersar los fondos',
      CONFIRMATION_ERROR_DESCRIPTION:
        'Ocurrió un error inesperado durante la confirmación de la dispersión.',
      EXPIRED_TITLE: 'No pudimos dispersar los fondos',
      EXPIRED_DESCRIPTION:
        'Expiró el tiempo para confirmar la dispersión. Por favor intentalo nuevamente.',
      INSUFFICIENT_BALANCE_TITLE: 'Tenés fondos insuficientes',
      INSUFFICIENT_BALANCE_DESCRIPTION:
        'Lo sentimos, no contás con fondos suficientes para realizar la dispersión. Verificá que tengas el saldo en tu cuenta antes de volver a intentar.',
      INVALID_COMPANIES_TITLE: 'Razones sociales inválidas',
      INVALID_COMPANIES_DESCRIPTION:
        'Las razones sociales asignadas al usuario no son válidas. Por favor contactá a un administrador para poder dispersar fondos.',
      INVALID_FILE_NAME_TITLE: 'Nombre de archivo inválido',
      INVALID_FILE_NAME_DESCRIPTION:
        'El nombre del archivo enviado no coincide con ninguno registrado en la base de datos.',
      FILE_CONTAINS_ERRORS_TITLE: 'Errores en archivo',
      FILE_CONTAINS_ERRORS_DESCRIPTION:
        'Encontramos errores en el archivo que enviaste. Por favor corregilos y volvé a intentarlo',
      UNAVAILABLE_TIME_TITLE: 'No podemos avanzar',
      SCHEDULE_UNAVAILABLE_TIME_DESCRIPTION:
        'No es posible programar una dispersión para las 12 am por tareas de mantenimiento, te pedimos que selecciones a partir de la 1 am y vuelvas a intentarlo. Muchas gracias.',
      UNAVAILABLE_TIME_DESCRIPTION:
        'En estos momentos no es posible dispersar fondos por tareas de mantenimiento, te pedimos que esperes hasta las 00:30hs y vuelvas a intentarlo. Muchas gracias.',
      INVALID_DATE: 'Es necesario que el día y horario programado sea futuro.',
      DEFAULT_BAD_REQUEST_ERROR: 'Ha ocurrido un error inesperado al subir el archivo',
      UNABLE_TO_FETCH_COMPANIES_TITLE: 'Error al buscar información de la/s razon/es social/es',
      UNABLE_TO_FETCH_COMPANIES_DESCRIPTION:
        'Ocurrió un error inesperado al obtener información de las razones sociales.',
      NOT_ENOUGH_BALANCE_AREA:
        'Lo sentimos, el área no cuenta con fondos suficientes para realizar la dispersión.',
      ALREADY_PROCESSING_TITLE: 'No podemos avanzar',
      ALREADY_PROCESSING_DESCRIPTION:
        'Detectamos que actualmente tenés una dispersión en curso, es necesario que la misma finalice para enviar una nueva. Recordá que podés ver el estado de tus dispersiones desde la sección “Mis dispersiones”.',
      DUPLICATE_TIME_FOR_SCHEDULED_TITLE: 'No podemos avanzar',
      DUPLICATE_TIME_FOR_SCHEDULED_DESCRIPTION:
        'Detectamos que ya tenés una dispersión programada para ese horario. Elegí un horario diferente para poder continuar. Podés consultar el estado de tus dispersiones en la sección "Mis dispersiones".',
    },
    FAST_DISPERSION: {
      TITLE: 'Dispersión rápida',
      NAME: 'Nombre',
      LAST_NAME: 'Apellido',
      CUIL: 'CUIL',
      PRODUCT: 'Producto',
      CATEGORY: 'Rubro',
      EXPORT_BUTTON: 'Exportar',
      NEXT_BUTTON: 'Continuar',
      AMOUNT: 'Monto',
      TITLE_AMOUNT: 'Ingresar monto a dispersar',
      DESCRIPTION_AMOUNT:
        'Se le dispersará el monto indicado a cada una de las cuentas seleccionadas.',
      DISPERSIONS_SUCCESS_TITLE_INSTANT: 'Dispersión en proceso',
      DISPERSIONS_SUCCESS_BODY_INSTANT:
        'En breve te estaremos enviando por correo los resultados del procesamiento de tu dispersión.\n\nTambién podés ver los resultados desde “Mis dispersiones”.',
      NOTIFICATION_MESSAGE: 'Mensaje de la notificación',
    },
  },
  HOME: {
    BALANCE_AVAILABLE: 'Saldo disponible',
    WELCOME_TITLE_EXTERNAL: '¡Hola, {{companyName}}!',
    WELCOME_BODY_EXTERNAL:
      'Te damos la bienvenida a nuestro sistema de gestión. Aquí encontrarás la información que necesites para gestionar los beneficios de Nubi para tus colaboradores.',
    WELCOME_TITLE_INTERNAL: '¡Hola, {{name}}!',
    WELCOME_BODY_INTERNAL: 'Te damos la bienvenida al sistema de gestión de Nubiz.',
  },
  INVOICES: {
    SELECT_PERIOD: 'Seleccioná el período de los comprobantes',
    ERRORS: {
      DEFAULT_ERROR_TITLE: 'Error al obtener comprobantes',
      DEFAULT_ERROR_BODY:
        'No se pudo obtener el enlace para descargar el comprobante en el período seleccionado.',
      NOT_FOUND_ERROR_TITLE: 'No encontramos el reporte',
      NOT_FOUND_ERROR_BODY: 'No se encontraron comprobantes de gastos en el período seleccionado.',
    },
  },
  LOGIN: {
    GET_STARTED: 'Empezá ahora',
    PASSWORD: 'Contraseña',
    USERNAME: 'Usuario',
    SELECT_COMPANY_TITLE: 'Seleccioná una razón social para comenzar a operar',
    SELECT_COMPANY_BODY: 'Luego podrás elegir otra desde tu perfil',
    WELCOME_BODY: 'Ingresá tus credenciales para acceder a nuestro sistema de gestión',
    WELCOME_TITLE: 'Comenzá a gestionar tus beneficios con Nubiz',
    VALIDATIONS: {
      USERNAME_REQUIRED: 'Usuario es obligatorio',
      PASSWORD_REQUIRED: 'Contraseña es obligatorio',
    },
    ERRORS: {
      ACCOUNT_ERROR_TITLE: 'Tu usuario debe ser configurado',
      NO_ROLES:
        'El usuario no posee roles. Para utilizar el backoffice es necesario tener al menos un rol asignado.',
      NO_PARTNER_DATA:
        'El usuario de autogestión no posee la información necesaria: razones sociales (customerData) y/o segmentos (types). Por favor contactá a un administrador.',
    },
  },
  LIMITS: {
    DELETE_MODAL: {
      TITLE: '¿Querés continuar con esta acción?',
      DESCRIPTION:
        'Estás a punto de eliminar el límite de <bold>"{{description}}"</bold> del tipo de transacción <bold>{{type}}</bold>.',
      SUCCESS: {
        TITLE: 'Límite eliminado con éxito',
      },
    },
    MODAL: {
      CONFIRM_DESCRIPTION: 'Confirmación de edición del límite',
      SUCCESS: 'Se han modificado los límites con éxito',
    },
    VIEW_DETAIL: 'Ver detalle',
    EDIT_DETAIL: 'Editar detalle del límite',
    DETAIL: {
      TITLE: 'Detalle del límite',
    },
    COLUMNS: {
      TRANSACTION_TYPE: 'Tipo de transacción',
      DESCRIPTION: 'Descripción',
    },
    FIELDS: {
      DOUBLE_FACTOR: 'Doble factor',
      TRANSACTION_LIMIT_RECEIVED: 'Monto por transacción destino',
      DAILY_LIMIT_RECEIVED: 'Acumulado diario destino',
      MONTHLY_LIMIT_RECEIVED: 'Acumulado mensual destino',
      DAILY_LIMIT_TX_RECEIVED: 'Cantidad de transacciones diario destino',
      MONTHLY_LIMIT_TX_RECEIVED: 'Cantidad de transacciones mensual destino',
      TRANSACTION_LIMIT_SENT: 'Monto por transacción origen',
      DAILY_LIMIT_SENT: 'Acumulado diario origen',
      MONTHLY_LIMIT_SENT: 'Acumulado mensual origen',
      DAILY_LIMIT_TX_SENT: 'Cantidad de transacciones diario origen',
      MONTHLY_LIMIT_TX_SENT: 'Cantidad de transacciones mensual origen',
    },
    ERRORS: {
      MAX_NUMBER: 'El monto máximo permitido es 9999999999999999',
      BAD_REQUEST_DESCRIPTION: 'Formato inválido. Revisá los datos ingresados.',
    },
  },
  MENU: {
    BALANCE: 'Mi saldo',
    CLIENTS: 'Clientes',
    CURRENCY_RATE: 'Cotizacion Dolar',
    COMMERCES: 'Comercios',
    CONSUMPTION_BY_COMMERCE: 'Consumos por comercios',
    CONSUMPTION_BY_CATEGORY: 'Consumos por rubros',
    CONSOLIDATED_DISPERSION: {
      TITLE: 'Listado de dispersiones consolidadas',
    },
    DISPERSIONS: {
      TITLE: 'Dispersar fondos',
      FAST_DISPERSION: 'Dispersión rápida',
      FILE_DISPERSION: 'Dispersar archivo',
      MY_DISPERSIONS: 'Mis dispersiones',
      PENDING: 'Gestión de dispersiones pendientes',
    },
    EMPLOYEES: 'Cuentas',
    MY_ACCOUNT: 'Mi cuenta',
    PROSPECTS: {
      TITLE: 'Alta de colaborador',
      ACCOUNT: 'Alta de cuenta',
      QUICK_CREATION: 'Pre-alta rápida',
      UPLOAD_FILE: 'Subir archivo',
      SEND_EMAIL: 'Email de registro',
      PENDING: 'Gestión de Pre-altas pendientes',
    },
    ADD_SEGMENT: 'Segmentos',
    SIGN_OUT: 'Cerrar sesión',
    REPORTS: 'Reportes',
    CONSUMPTION: {
      TITLE: 'Reportes',
      LIST: 'Listado de consumos',
      INVOICES: 'Comprobantes de gastos',
    },
    USERS_MANAGEMENT: {
      TITLE: 'Gestión de usuarios',
      LIST: 'Listado de usuarios',
      CREATE: 'Agregar nuevo usuario',
    },
    PENDING_CUSTOMERS: {
      TITLE: 'Gestión de razones sociales',
    },
    LIMITS_MANAGEMENT: {
      TITLE: 'Gestión de límites',
    },
    GIFT_CARDS: {
      TITLE: 'Tarjetas innominadas',
      TITLE_UPLOAD: 'Subir archivo',
      TITLE_LIST: 'Mis altas',
    },
    TRANSFER_RECEIPT: {
      TITLE: 'Recibo de transferencia',
    },
  },
  GIFT_CARDS: {
    DROPZONE_TITLE: 'Subir archivo de alta de tarjetas innominadas',
    CONFIRMATION_MODAL_one:
      'Estás a punto de generar <bold>{{total}}</bold> tarjeta innominada para <bold>{{companyName}}</bold> por el monto <bold>{{totalAmount}}</bold>. ¿Estás de acuerdo?',
    CONFIRMATION_MODAL:
      'Estás a punto de generar <bold>{{total}}</bold> tarjetas innominadas para <bold>{{companyName}}</bold> por el monto <bold>{{totalAmount}}</bold>. ¿Estás de acuerdo?',
    SUCCESS:
      'Se ejecutó con éxito la carga de tarjetas innominadas.\n\nPodés ver tus cargas desde “Mis altas”.',
    GO_TO_LIST: 'Ir a Mis altas',
    RESULT: 'Resultado',
    RETRY: 'Reprocesar alta',
    RETRY_SUCCESS: 'Se envió el reproceso del alta.',
    REGISTRATION_STATUS: {
      PENDING_USER: 'Pendiente de registro',
      FAILED_USER: 'Error de usuario',
      PENDING_ACCOUNT: 'Pendiente de cuenta',
      FAILED_ACCOUNT: 'Error en cuenta',
      PENDING_PREPAID_CARD: 'Pendiente de tarjeta',
      FAILED_PREPAID_CARD: 'Error en tarjeta',
      PENDING_USER_PRODUCT: 'Pendiente de producto',
      FAILED_USER_PRODUCT: 'Error de producto',
      PENDING_DISPERSION: 'Pendiente de dispersión',
      FAILED_DISPERSION: 'Error de dispersión',
      PENDING_TOKEN: 'Token pendiente',
      FAILED_TOKEN: 'Error de token',
      PROCESSED: 'Acreditado',
    },
  },
  EXCHANGE: {
    TITLE: 'Actualización de la cotización del dolar',
    INPUT_PLACEHOLDER: 'Ingresá la cotización del día',
    SCHEDULED_SWITCH_MESSAGE: '¿Querés programar la cotización?',
    INPUT_PLACEHOLDER_SCHEDULE: 'Ingresá la fecha',
    SCHEDULED_MESSAGE: 'Recordá que solo se puede programar hasta un máximo de 2 días.',
    BUTTON_SAVE_TEXT: 'Guardar',
    SUBTITLE: 'Últimas cotizaciones',
    TABLE_DATE_TITLE: 'Fecha',
    TABLE_START_TITLE: 'Vigente desde',
    TABLE_EXCHANGE_TITLE: 'Cotización',
    ERRORS: {
      TITLE_POST: 'Error al crear la cotización',
      MESSAGE_POST: ' - Contactar al equipo Banking.',
      TITLE_GET: 'Error',
      MESSAGE_GET: ' - No pudimos obtener las últimas cotizaciones.',
    },
    SAVE_TITLE: 'Carga exitosa',
    SAVE_MESSAGE: 'En breve se visualizará en la tabla.',
    SAVE_MESSAGE_SCHEDULED: 'Se programó la cotización.',
  },
  MOVEMENTS: {
    ACCOUNT_NUMBER: 'Número de cuenta',
    ACCOUNT_TO: 'Cuenta del destinatario',
    BUSINESS_DATE: 'Fecha de negocio',
    CONCILIATION: 'Conciliación',
    CONCILIATION_STATUS: 'Estado de conciliación',
    DETAILS_TITLE: 'Detalles del movimiento',
    FILTERS_TITLE: 'Filtrar movimientos',
    MOVEMENT_ID: 'Id de movimiento',
    RESULT_CODE: 'Código de resultado',
    STATUS_DESCRIPTION: 'Descripción del estado',
    TITLE: 'Movimientos',
    TRACE_NUMBER: 'Número de seguimiento',
    TRANSACTION_ID: 'Id de transacción',
    TRANSACTION_TYPE: 'Tipo de transacción',
    USER_FROM: 'Usuario origen',
    USER_FROM_ADDITIONAL_DATA: 'Otros datos del originante',
    USER_TO: 'Wallet id usuario destino',
    USER_TO_ADDITIONAL_DATA: 'Otros datos del destinatario',
    ERRORS: {
      GENERIC_MOVEMENTS_FETCH_ERROR: 'Ha ocurrido un error al buscar la información de la cuenta.',
      NOT_FOUND: 'No se encontró la transacción solicitada',
      MOVEMENT_FETCH_GENERIC_ERROR: 'Ocurrio un error al buscar el movimiento',
    },
    CONCEPT: 'Concepto',
  },
  PROSPECTS: {
    ADD_PROSPECTS_FILE_TITLE: 'Pre-alta de colaboradores por archivo',
    ADD_PROSPECTS_QUICK_TITLE: 'Pre-alta rápida',
    ADD_PROSPECTS_SEND_EMAIL: 'Enviar email de registro',
    ADD_PROSPECTS_SELECTED_COMPANY:
      'Tenés seleccionada la razón social {{company}}. Podes cambiarla desde tu perfil, en el menú superior.',
    ADD_PROSPECT_QUICK_CREATION: 'Agregar colaborador',
    CSV_ERRORS_TITLE: 'Encontramos los siguientes errores en tu archivo de pre-altas:',
    DROPZONE_TEXT:
      'Arrastrá aquí un único archivo con el detalle de los colaboradores, o hacé clic para seleccionarlo',
    SEND_EMAIL: {
      TITLE: 'Envío de email de registro',
      DESCRIPTION:
        'Seleccioná el segmento deseado para enviar el email de registro a aquellos colaboradores los cuales no fueron notificados al momento de crear la pre-alta.',
      DESCRIPTION_CLIENT:
        'Se enviará el email de registro para aquellos colaboradores los cuales no fueron notificados al momento de crear la pre-alta.',
      BODY_CLIENT: '¿Desea enviar el email de registro a los colaboradores?',
      BUTTON: 'Enviar email',
      SUCCESS: 'Los emails fueron enviados correctamente',
      MODAL: {
        TITLE: '¿Querés continuar con esta acción?',
        DESCRIPTION:
          'Estás a punto de enviar el email de registro a los colaboradores del segmento <1>{{segment}}</1> ¿Estás de acuerdo?',
        DESCRIPTION_CLIENT:
          'Estás a punto de enviar el email de registro a tus colaboradores ¿Estás de acuerdo?',
      },
    },
    ERRORS: {
      CONFIRMATION_ERROR_TITLE: 'No pudimos realizar la pre-alta',
      CONFIRMATION_ERROR_DESCRIPTION:
        'Ocurrió un error inesperado durante la confirmación de la pre-alta.',
      EXPIRED_TITLE: 'No pudimos realizar la pre-alta',
      EXPIRED_DESCRIPTION:
        'Expiró el tiempo para confirmar la pre-alta. Por favor intentalo nuevamente.',
      INVALID_SEGMENT_NAME_TITLE: 'Nombre de segmento inválido',
      INVALID_FILE_NAME_DESCRIPTION:
        'El nombre del segmento enviado no coincide con ninguno registrado en la base de datos.',
      FILE_CONTAINS_ERRORS_TITLE: 'Errores en archivo',
      FILE_CONTAINS_ERRORS_DESCRIPTION:
        'Encontramos errores en el archivo que enviaste. Por favor corregilos y volvé a intentarlo',
      DEFAULT_BAD_REQUEST_ERROR: 'Ha ocurrido un error inesperado al subir el archivo',
    },
    QUICK_CREATION_MODAL: {
      TITLE: 'Agregar nuevo colaborador',
      NAME_LABEL: 'Nombre',
      LASTNAME_LABEL: 'Apellido',
      CUIL_LABEL: 'CUIL',
      EMAIL_LABEL: 'Email',
      PRODUCT_LABEL: 'Producto',
      CARD_TYPE_LABEL: 'Tipo de tarjeta',
      CATEGORY_LABEL: 'Rubro',
      BUTTON_SUBMIT_TEXT: 'Agregar',
      BUTTON_CANCEL_TEXT: 'Cancelar',
      ERRORS: {
        FIELD_REQUIRED: 'El campo es obligatorio',
        INVALID_EMAIL: 'Ingrese una dirección de correo electrónico válida',
        INVALID_CUIL: 'Formato de CUIL inválido',
        CUIL_EXIST: 'El CUIL ya existe',
        EMAIL_EXIST: 'El Email ya existe',
        INVALID_NAME: 'El nombre es inválido',
        INVALID_LASTNAME: 'El apellido es inválido',
      },
    },
    QUICK_CREATION_TABLE: {
      NAME: 'Nombre',
      LASTNAME: 'Apellido',
      CUIL: 'CUIL',
      EMAIL: 'Email',
      PRODUCT: 'Producto',
      CARD_TYPE: 'Tipo de tarjeta',
      CATEGORY: 'Rubro',
      NOT_FOUND: 'Agrega un colaborador para continuar',
    },
    MODAL_MESSAGE_with_area:
      'Estás a punto de dar de alta <strong>{{total}}</strong> colaboradores del segmento <strong>{{segment}}</strong>, el área <strong>{{area}}</strong> y razón social <strong>{{company}}</strong>.',
    MODAL_MESSAGE_with_area_one:
      'Estás a punto de dar de alta <strong>{{total}}</strong> colaborador del segmento <strong>{{segment}}</strong>, el área <strong>{{area}}</strong> y razón social <strong>{{company}}</strong>.',
    MODAL_MESSAGE_without_area:
      'Estás a punto de dar de alta <strong>{{total}}</strong> colaboradores del segmento <strong>{{segment}}</strong> y razón social <strong>{{company}}</strong>.',
    MODAL_MESSAGE_without_area_one:
      'Estás a punto de dar de alta <strong>{{total}}</strong> colaborador del segmento <strong>{{segment}}</strong> y razón social <strong>{{company}}</strong>.',
    MODAL_MESSAGE_SIMPLE_CLIENTS:
      'Estás a punto de dar de alta <strong>{{total}}</strong> colaboradores de <strong>{{company}}</strong>. ¿Estás de acuerdo?',
    MODAL_MESSAGE_SIMPLE_CLIENTS_one:
      'Estás a punto de dar de alta <strong>{{total}}</strong> colaborador de <strong>{{company}}</strong>. ¿Estás de acuerdo?',
    MODAL_TITLE: '¿Querés continuar con esta acción?',
    SELECT_SEGMENT: 'Seleccioná un segmento',
    SEND_DATA: 'Enviar',
    SUCCESS_BODY:
      'En breve te estaremos enviando por correo los resultados del procesamiento de tu archivo.',
    SUCCESS_TITLE: '¡Listo! ¡Has enviado tu archivo exitosamente!',
    SUCCESS_BODY_CREATION:
      'En breve te estaremos enviando por correo los resultados del procesamiento de tu formulario.',
    SUCCESS_TITLE_CREATION: '¡Listo! ¡Has enviado tu formulario exitosamente!',

    ERROR_TITLE: '',
    TITLE: 'Pre-alta de colaboradores',
    TITLE_QUICK_CREATION: 'Pre-alta rápida de colaboradores',
    UPLOAD_FILE: 'Subir archivo de pre-alta',
  },
  CATEGORIES: {
    GENERIC: 'ILIMITADO',
  },
  FAQ: {
    HELP: 'Ayuda',
    HELP_DIALOG: {
      TITLE: 'Cómo ingresar a la Web de Autogestión',
      INTRO:
        'Para poder acceder a nuestra Web de autogestión se precisa doble factor de autenticación. Para esto vas a precisar descargar en tu celular la aplicación Google Autenticator:',
      LINKS: {
        GOOGLE_PLAY: {
          TEXT: 'Link de descarga para Android',
          TEXTLINK: 'Google Authenticator - Apps on Google Play',
          LINK: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US&pli=1',
        },
        APP_STORE: {
          TEXT: 'Link de descarga para Iphone',
          TEXTLINK: 'Google Authenticator',
          LINK: 'https://apps.apple.com/us/app/google-authenticator/id388497605',
        },
      },
      STEPS: {
        MAIL: 'La primera vez que ingreses a la web vas a tener que utilizar una password que te enviaremos por mail.',
        QR: 'Luego verás un QR para enrolar tu cuenta en la aplicación Autenticator.',
        CAMERA:
          'Con  la aplicación instalada y abierta en el celular sobre el margen inferior derecho de la pantalla del teléfono aparecerá un “+”, debemos ingresar allí y seleccionar “Escanear un código QR”, con ello se abrirá la cámara. ',
        SCAN: 'Debés escanear el QR que ves en pantalla.',
        DIGITS:
          'En la pantalla de inicio de sesión  ingresamos el código de 6 dígitos que nos aparece en la aplicación Autenticator con el mail que acabamos de asociar.',
        PASSWORD: 'Podés modificar tu password  haciendo click en ¿Olvidó su contraseña?',
      },
    },
    SUPPORT: 'Soporte',
  },
  USERS: {
    SELECT_ACCOUNT_NUMBER: 'Seleccioná un número de cuenta',
    ERRORS: {
      UNABLE_TO_FETCH_ACCOUNT_NUMBERS_TITLE: 'Error al buscar números de cuenta',
      UNABLE_TO_FETCH_ACCOUNT_NUMBERS_DESCRIPTION:
        'Ocurrió un error inesperado al obtener números de cuenta.',
    },
  },
  PENDING_PROSPECTS: {
    SEARCH_TITLE: 'Buscar Pre-altas',
    USERS_COUNT: 'Cantidad de usuarios',
    FILE_NAME: 'Archivo',
    CREATED_AT: 'Fecha de carga',
    STATUS: {
      PENDING: 'Pendiente',
      APPROVED: 'Aprobado',
      REJECTED: 'Rechazado',
    },
    ALERT_MESSAGES: {
      APPROVED: 'La pre-alta se aprobó con éxito.',
      REJECTED: 'La pre-alta se rechazó con éxito.',
      APPROVED_ERROR: 'Se produjo un error al aprobar la pre-alta.',
      REJECTED_ERROR: 'Se produjo un error al rechazar la pre-alta.',
    },
    CONFIRMATION_MODAL: {
      APPROVE_one:
        'Estás a punto de aprobar el alta de <s>{{usersCount}}</s> colaborador de <s>{{companyName}}</s>.',
      APPROVE_other:
        'Estás a punto de aprobar el alta de <s>{{usersCount}}</s> colaboradores de <s>{{companyName}}</s>.',
      REJECT_one:
        'Estás a punto de rechazar el alta de <s>{{usersCount}}</s> colaborador de <s>{{companyName}}</s>.',
      REJECT_other:
        'Estás a punto de rechazar el alta de <s>{{usersCount}}</s> colaboradores de <s>{{companyName}}</s>.',
    },
    OWN_REQUEST_INFO: 'Es necesario que otro usuario te apruebe el alta',
    DETAIL: {
      TITLE: 'Detalle de la pre-alta',
      MISSING: 'No se encontraron datos para la pre-alta seleccionada.',
      ID: 'ID',
      CREATED_BY: 'Creado por',
      USERS_COUNT: 'Cantidad de usuarios',
      CUSTOMER_ID: 'ID de razón social',
      CUSTOMER_NAME: 'Razón social',
      SEGMENT_NAME: 'Segmento',
      COMPANY_CUIT: 'CUIT',
      FILE_PATH: 'Ruta del archivo',
      FILE_NAME: 'Archivo',
      STATUS: 'Estado',
      RESOLVED_BY: 'Resuelto por',
      RESOLVED_AT: 'Fecha de resolución',
      CREATED_AT: 'Fecha de carga',
      UPDATED_AT: 'Fecha de actualización',
    },
  },
  PENDING_DISPERSIONS: {
    SEARCH_TITLE: 'Buscar dispersiones pendientes',
    USERS_COUNT: 'Cantidad de usuarios',
    TOTAL_AMOUNT: 'Monto total',
    STATUS: {
      PENDING: 'Pendiente',
      APPROVED: 'Aprobado',
      REJECTED: 'Rechazado',
    },
    ALERT_MESSAGES: {
      APPROVED: 'La dispersión se aprobó con éxito.',
      REJECTED: 'La dispersión se rechazó con éxito.',
      APPROVED_ERROR: 'Se produjo un error al aprobar la creación de la dispersión.',
      REJECTED_ERROR: 'Se produjo un error al rechazar la creación de la dispersión.',
    },
    CONFIRMATION_MODAL: {
      APPROVE:
        'Estás a punto de aprobar la creación de la dispersión de <s>{{companyName}}</s> por <s>{{formattedAmount}}</s>.',
      REJECT:
        'Estás a punto de rechazar la creación de la dispersión de <s>{{companyName}}</s> por <s>{{formattedAmount}}</s>.',
    },
    OWN_REQUEST_INFO: 'Es necesario que otro usuario te apruebe la creación de la dispersión',
    DETAIL: {
      TITLE: 'Detalle de dispersión',
      MISSING: 'No se encontraron datos para la dispersión seleccionada.',
      ID: 'ID',
      DISPERSION_ID: 'ID de dispersión',
      CUSTOMER_NAME: 'Razón social',
      CUSTOMER_ID: 'ID de razón social',
      AREA: 'Área',
      AREA_ID: 'ID de área',
      USERS_COUNT: 'Cantidad de usuarios',
      ATTEMPTED_AMOUNT: 'Monto total',
      FILE_NAME: 'Archivo',
      FILE_PATH: 'Ruta del archivo',
      SCHEDULED_DATE: 'Fecha programada',
      STATUS: 'Estado',
      CREATED_BY: 'Creado por',
      CREATED_AT: 'Fecha de creación',
      UPDATED_AT: 'Fecha de actualización',
      RESOLVED_BY: 'Resuelto por',
      RESOLVED_AT: 'Fecha de resolución',
    },
  },
  PENDING_CUSTOMERS: {
    SEARCH_TITLE: 'Buscar altas de razones sociales',
    STATUS: {
      PENDING: 'Pendiente',
      ACCEPTED: 'Aceptada',
      APPROVED: 'Aprobada',
      REJECTED: 'Rechazada',
    },
    ALERT_MESSAGES: {
      APPROVED: 'Aprobación exitosa, la razón social fue creada con éxito.',
      REJECTED: 'La razón social se rechazó con éxito.',
      APPROVED_ERROR: 'Se produjo un error al aprobar la razón social.',
      REJECTED_ERROR: 'Se produjo un error al rechazar la razón social.',
    },
    CONFIRMATION_MODAL: {
      APPROVE:
        'Estás a punto de aprobar el alta de la razón social <s>{{customerName}}</s> (CUIT <s>{{cuit}}</s>).',
      REJECT:
        'Estás a punto de rechazar el alta de la razón social <s>{{customerName}}</s> (CUIT <s>{{cuit}}</s>).',
    },
    OWN_REQUEST_INFO: 'Es necesario que otro Supervisor te apruebe la creación',
    RESOLVED_BY: 'Resuelto por',
    RESOLVED_AT: 'Fecha de resolución',
    DETAIL: {
      TITLE: 'Detalle de razón social',
      COMPANY_DATA: 'Datos de la razón social',
      NOT_FOUND:
        'No se encontró la información de la razón social. Volvé al listado e intentá nuevamente.',
    },
  },
  USERS_MANAGEMENT: {
    SEARCH_USERS: 'Buscar usuarios',
    GO_TO_USERS_LIST: 'Ir a Listado de usuarios',
    USER_STATUS: {
      PENDING: 'Pre-creado',
      APPROVED: 'Aprobado',
      REJECTED: 'Rechazado',
      CREATED: 'Creado',
    },
    FIRST_TIME_LOGIN: 'Primer ingreso',
    ERROR: {
      INPUT_MAX_LENGTH: 'Longitud inválida, máximo 50 caracteres',
      EMAIL_MAX_LENGTH: 'Longitud inválida, máximo 255 caracteres',
    },
    ALERT_MESSAGES: {
      TITLE_SUCCESS: 'Solicitud generada',
      SUCCESS: 'La solicitud quedó cargada exitosamente.',
      FILTER_LOAD_ERROR: 'No se pudo cargar el listado para filtrar. Intentá nuevamente.',
      ERROR_DUPLICATED_EMAIL:
        'El email proporcionado ya está asignado a un usuario. Intentá con otro diferente.',
      ERROR_AREA_CUSTOMER:
        'Las áreas proporcionadas no pertenecen a los clientes seleccionados. Intentá con otro diferente.',
      APPROVED_USER: 'El usuario se aprobó con éxito.',
      REJECTED_USER: 'El usuario se rechazó con éxito.',
      APPROVED_USER_ERROR: 'Se produjo un error al aprobar la creación del usuario.',
      REJECTED_USER_ERROR: 'Se produjo un error al rechazar la creación del usuario.',
      CREATED_USER: 'Usuario creado con éxito.',
      CREATED_USER_ERROR: 'Se produjo un error al crear el usuario.',
      RESEND_EMAIL: 'El email se reenvió con éxito.',
      RESEND_EMAIL_ERROR: 'Se produjo un error al reenviar el email.',
    },
    ACTIONS: {
      CREATE: 'Crear el usuario',
      RESEND_EMAIL: 'Reenviar email',
    },
    CONFIRMATION_MODAL: {
      DESCRIPTION_other:
        'Estás a punto de crear el pedido de alta de <s>{{name}}</s> con el usuario <s>{{email}}</s> para gestionar las razones sociales <s>{{customerId}}</s>.',
      APPROVE_USER_other:
        'Estás a punto de aprobar la creación del usuario <s>{{email}}</s> para gestionar las razones sociales <s>{{companies}}</s>.',
      REJECT_USER_other:
        'Estás a punto de rechazar la creación del usuario <s>{{email}}</s> para gestionar las razones sociales <s>{{companies}}</s>.',
      CREATE_USER_other:
        'Estás a punto de crear el usuario <s>{{email}}</s> para gestionar las razones sociales <s>{{companies}}</s>.',
      DESCRIPTION_one:
        'Estás a punto de crear el pedido de alta de <s>{{name}}</s> con el usuario <s>{{email}}</s> para gestionar la razón social <s>{{customerId}}</s>.',
      APPROVE_USER_one:
        'Estás a punto de aprobar la creación del usuario <s>{{email}}</s> para gestionar la razón social <s>{{companies}}</s>.',
      REJECT_USER_one:
        'Estás a punto de rechazar la creación del usuario <s>{{email}}</s> para gestionar la razón social <s>{{companies}}</s>.',
      CREATE_USER_one:
        'Estás a punto de crear el usuario <s>{{email}}</s> para gestionar la razón social <s>{{companies}}</s>.',
      RESEND_USER_other:
        'Estás a punto de reenviar el email de confirmación al usuario <s>{{email}}</s>.',
      RESEND_USER_one:
        'Estás a punto de reenviar el email de confirmación al usuario <s>{{email}}</s>.',
    },
  },
  HELP_SCREEN: {
    LOGIN_PROBLEMS: {
      TITLE: 'Cómo ingresar a la Web de Autogestión',
      FIRST_ITEM:
        'Para poder acceder a nuestra Web de autogestión se precisa doble factor de autenticación. Para esto vas a precisar descargar en tu celular la aplicación Google Authenticator:',
      SECOND_ITEM:
        'La primera vez que ingreses a la web vas a tener que hacer click en “¿Olvidó su contraseña?” para que puedas establecer una de forma segura.',
      THIRD_ITEM:
        'En la pantalla de login, luego de ingresar tus credenciales verás un QR para enrolar tu cuenta en la aplicación Authenticator.',
      FOURTH_ITEM:
        'Con  la aplicación instalada y abierta en el celular sobre el margen inferior derecho de la pantalla del teléfono aparecerá un “+”, debemos ingresar allí y seleccionar “Escanear un código QR”, con ello se abrirá la cámara.',
      FIFTH_ITEM: 'Debés escanear el QR que ves en pantalla.',
      SIXTH_ITEM:
        'En la pantalla de inicio de sesión ingresamos el código de 6 dígitos que nos aparece en la aplicación Authenticator con el mail que acabamos de asociar.',
      SUBLIST_FIRST_ITEM: {
        TEXT: 'Link de descarga para Android',
        TEXTLINK: 'Google Authenticator - Apps on Google Play',
      },
      SUBLIST_SECOND_ITEM: {
        TEXT: 'Link de descarga para Iphone',
        TEXTLINK: 'Google Authenticator',
      },
    },
    MY_BALANCE: {
      TITLE: 'Mi saldo',
      FIRST_ITEM:
        'En esta sección podrás ver el saldo de tu cuenta en Nubi con el que contás para hacer dispersiones. También se listan los movimientos que acreditan o debitan saldo.',
    },
    ACCOUNTS: {
      TITLE: 'Cuentas',
      BODY: 'En este listado se encuentran las cuentas de las personas. Si una persona tiene más de una cuenta, aparecerá más de una vez.',
      FIRST_ITEM_TITLE: 'Exportar listado a Excel',
      FIRST_ITEM_BODY:
        'Se debe hacer clic en el icono con forma de archivo ubicado en la parte superior de la pantalla.',
      SECOND_ITEM_TITLE: 'Ver detalle de una cuenta',
      SECOND_ITEM_BODY: 'Se debe hacer clic en cualquier parte de la fila.',
      THIRD_ITEM_TITLE: 'Dispersar fondos',
      THIRD_ITEM_BODY:
        'Seleccionar las cuentas y luego hacer clic en Dispersar, ingresar el monto y luego confirmar.',
      FOURTH_ITEM_TITLE: 'Recuperar dinero',
      FOURTH_ITEM_BODY:
        'Solo se puede recuperar dinero si la cuenta es Corporativa o de Almuerzo desde el detalle de la cuenta. Para hacerlo, entrar al detalle de la cuenta y hacer clic en el icono que tiene 3 puntos en forma vertical que está al lado del número de cuenta y hacer clic en “Recuperar dinero”.',
      FIFTH_ITEM_TITLE: 'Inhabilitar cuenta para dispersar',
      FIFTH_ITEM_BODY:
        'Para evitar dispersarse dinero a una cuenta, deshabilitar la opción  “Habilitado para dispersión” que se encuentra en el detalle de la cuenta.',
      SIXTH_ITEM_TITLE: 'Cambiar rubro de la cuenta',
      SIXTH_ITEM_BODY:
        'Hacer clic en el icono que tiene 3 puntos en forma vertical que está al lado del número de cuenta y hacer clic en “Editar rubro”.',
    },
    CONSUMPTIONS_LIST: {
      TITLE: 'Listado de consumos',
      BODY: 'En esta sección podés visualizar los consumos que tus colaboradores realizaron con sus tarjetas Corporativas o de Almuerzo.',
      FIRST_ITEM_TITLE: 'Información que se visualiza',
      FIRST_ITEM_BODY:
        'Por defecto se muestran los consumos del último mes.\nSolo se verán consumos realizados a partir del 1° de agosto.\nLos datos se ven a día vencido, es decir, si se realizó un consumo hoy, aparecerá mañana.',
      SECOND_ITEM_TITLE: 'Exportar listado a Excel',
      SECOND_ITEM_BODY:
        'Se puede descargar en excel el listado haciendo clic en el icono similar a un archivo ubicado en la parte superior.',
      THIRD_ITEM_TITLE: 'Comprobantes',
      THIRD_ITEM_BODY:
        'Si la persona cargó el comprobante de pago desde la aplicación, en la última columna del listado aparecerá el link para descargarlo.',
      FOURTH_ITEM_TITLE: 'Comercios',
      FOURTH_ITEM_BODY:
        'Los comercios que se listan se obtienen a partir de los nombres que el comercio configuró en su terminal de pago. Desde Nubi no tenemos más información que la que se expone en el listado.',
    },
    DOWNLOAD_RECEIPTS: {
      TITLE: 'Descarga de comprobantes',
      FIRST_ITEM:
        'En esta sección podés descargar los comprobantes de los consumos que realizaron con sus tarjetas Corporativas o de Almuerzo seleccionando un año y mes específico.',
    },
    DISPERSSIONS: {
      TITLE: 'Dispersar fondos',
      FIRST_ITEM: {
        TITLE: 'Dispersar fondos > Mis dispersiones',
        BODY: 'Listado donde se visualizan todas las dispersiones de fondos realizadas.',
        FIRST_TITLE: 'Información',
        FIRST_BODY:
          'En el monto original se especifica el monto de dinero que se intentó dispersar.\nEn el monto acreditado se especifica el monto que realmente se acreditó.\nPuede haber casos en que esos valores difieran por una falla en alguna acreditación.',
        SECOND_TITLE: 'Detalle de la dispersión',
        SECOND_BODY:
          'Para ver el detalle de lo dispersado hacer clic en cualquier lugar del registro.',
      },
      SECOND_ITEM: {
        TITLE: 'Dispersar fondos > Dispersar por archivo',
        BODY: 'Esta sección es muy útil cuando se precisa dispersar dinero a muchas cuentas y montos diferentes a cada una.\nSi precisás dispersar un monto único te recomendamos hacerlo desde la sección Cuentas.',
        FIRST_TITLE: 'Descargar cuentas',
        FIRST_BODY:
          'Sirve para descargar un archivo excel con todas las cuentas incluyendo producto y rubro para que puedas identificar fácilmente en caso que algún colaborador posea más de una.',
        SECOND_TITLE: 'Procesar el archivo',
        SECOND_BODY:
          'Luego de completar la plantilla se debe subir el archivo y confirmar la dispersión.\nCuando este proceso finalice recibirás un mail con el resultado y también podrás verlo desde la sección Mis dispersiones.',
        THIRD_TITLE: 'Programar una dispersión',
        THIRD_BODY:
          'Luego de subir la plantilla se puede programar el día y hora en el que se procesarán las dispersiones.',
      },
    },
    SUPPORT_MAIL: {
      TITLE: 'Soporte para la Web de Autogestión',
      TEXT: 'Si tenés más dudas podés escribirnos a contacto_autogestion@nubi.com.ar y te responderemos con gusto.',
      FIRST_ITEM:
        'Si tenés dudas sobre la <bold>Web de Autogestión</bold>, escribinos a <CustomLink>contacto_autogestion@nubi.com.ar</CustomLink> y te responderemos tan pronto como podamos.',
      SECOND_ITEM:
        'Recordá que nuestro horario de atención es de <bold>Lunes a Viernes de 8:00 a 18:00h</bold>.',
      THIRD_ITEM:
        'Si tenés consultas sobre otros temas no relacionados con la web como altas, dispersiones y transferencias, contactanos a <CustomLink>operations@nubizcorp.com</CustomLink>',
    },
  },
  CONSUMPTION: {
    FILTERS_TITLE: 'Filtrar consumos',
    NOT_FOUND: 'No posee comprobantes',
    DOWNLOAD: 'Exportar consumos',
    XLS_FILE: 'consumos',
    BY_COMMERCE: 'Consumos_por_comercio{{extension}}',
    BY_CATEGORY: 'Consumos_por_rubro{{extension}}',
    FILE_NAME: 'comprobante-{{fileName}}',
    CONSUMPTION_RATE: '% Consumos',
    TRX_COUNT: 'Consumos',
    CATEGORY_AMOUNT: 'Importe',
    BALANCE_AVERAGE_TX: 'Promedio consumos',
    NOT_SELECTED_PRODUCT: 'Seleccione un producto',
    WARNING:
      'Recordá que este reporte muestra sólo los primeros 10 comercios con la mayor cantidad de consumos',
  },
  TRANSFER_RECEIPT: {
    TITLE: 'Filtrar transferencias',
    RECEIPT_TITLE: 'Recibo de transferencia',
    TRANSACTION_TYPES: {
      BALANCE_RECOVERY: 'Recupero de balance',
      FUND: 'Transferencia de fondos',
      ADJUSTMENT: 'Ajuste de balance',
      DISPERSION: 'Dispersión de balance',
      ASSIGNMENT: 'Asignación de balance',
      REASSIGNMENT: 'Reasignación de balance',
    },
  },
};
export default translations;
